/* globals require */
/* exported gmapInit */

require('babel-polyfill');

import Vue from 'vue';
import Tortilla from 'tortilla';
import VeeValidate from 'vee-validate';
import VueYouTubeEmbed from 'vue-youtube-embed';

window.Vue = Vue;
window.Tortilla = Tortilla;
window.$ = window.jQuery = require('jquery');
window.events = window.eventsBus = new Vue();
Vue.prototype.$eventsBus = window.events;

var apiKey = document.querySelector('meta[name="gmaps-key"]').content;

Tortilla.Xhr.setDefaultHeaders({
  'X-Requested-With': 'XMLHttpRequest'
});

Vue.use(Tortilla.Components.Bokeh);
Vue.use(Tortilla.Components.Recaptcha);



const ControlPosition = Tortilla.Maps.Utils.ControlPosition;

Vue.use(Tortilla.Maps.GoogleMap, {
  apiKey: apiKey,
  options: {
    // this pads the map after fitBounds is run to ensure the large marker pins
    // remain in view
    boundaryPadding: 45
  },
  config: {
    mapTypeControl: false,
    mapTypeControlOptions: {
      style: 1,
      position: ControlPosition.TOP_LEFT
    },
    zoomControl: true,
    zoomControlOptions: {
      position: ControlPosition.RIGHT_CENTER
    },
    scaleControl: true,
    streetViewControl: false,
    streetViewControlOptions: {
      position: ControlPosition.LEFT
    },
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: ControlPosition.RIGHT_CENTER
    },
    disableDefaultUI: true
  }
});

Vue.use(VeeValidate, {
  fieldsBagName: 'vFields'
});

Vue.use(VueYouTubeEmbed);

require('bootstrap');
